import React, { useEffect, useState } from 'react'
import NavTitle from '../../../components/nav-title'
import TextNavTitle from '../../../components/TextNavTitle'
import CardCustom from '../../../components/custom/card-custom'
import { Button, Col, Row, Table } from 'react-bootstrap'
import CustomDatePicker from '../../../components/custom/CustomDatePicker'
import { BsArrowClockwise, BsSearch, BsSliders2Vertical } from 'react-icons/bs'
import { FaPlus, FaRegTrashCan } from 'react-icons/fa6'
import { fnDateEn } from '../../../helper/fnDateEn'
import { Link } from 'react-router-dom'
import { PaginationControl } from 'react-bootstrap-pagination-control'
import ModalImportFile from './ModalImportFile'
import SwalCustomSuccess from '../../../alert/swal-success'
import Error_false from '../../../components/error/error-false'
import SwalCustom from '../../../alert/swal-custom'
import Swal from 'sweetalert2'
import { PAGE_INCOME_DILIG_DETAIL } from '../../../router/routes'
import TableSkeletonBody from '../../../components/custom/TableSkeletonBody'
import {
  deleteIncomeDiligenceAPI,
  listIncomeDiligenceAPI
} from '../../../services/income/diligence'
import ModalMoreFilter from '../shift/ModalMoreFilter'
import NavRoleOrg from '../../../components/nav-role-org'
import { useSelector } from 'react-redux'

export default function IncomeDiligenceAllowancePage() {
  const totalLimits = 20
  const orgId = useSelector((state) => state.roleReducer.role)

  const [totalRows, setTotalRow] = useState(0)
  const [page, setPage] = useState(1)
  const [showFilter, setShowFilter] = useState({ isShow: false, data: null })
  const [showImport, setShowImport] = useState({ isShow: false, data: null })
  const [dataTable, setDataTable] = useState([])
  const [bodyFilter, setBodyFilter] = useState()
  const [isLoading, setIsLoading] = useState(true)
  const [selectMonth, setSelectMonth] = useState(null)
  useEffect(() => {
    const body = {
      page: 1,
      orgId
    }
    fnGetData(body)
  }, [orgId])

  const fnGetData = async (body) => {
    setIsLoading(true)
    setBodyFilter(body)
    setPage(body.page)
    const resp = await listIncomeDiligenceAPI(body)
    setIsLoading(false)
    if (!resp) return
    if (resp.status) {
      setDataTable(resp.result)
      setTotalRow(resp.totalRows)
    } else {
      setTotalRow(0)
      setDataTable([])
    }
  }

  const fnDeleteData = (periodDate) => {
    SwalCustom({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#2C5DFE',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
      preConfirm: async () => {
        try {
          const body = {
            periodDate,
            orgId
          }
          const resp = await deleteIncomeDiligenceAPI(body)
          if (!resp) return
          if (resp.status) {
            SwalCustomSuccess()
          } else {
            Error_false(resp)
          }
        } catch (error) {
          Swal.showValidationMessage(`
              Request failed: ${error}
            `)
        }
      },
      allowOutsideClick: () => !Swal.isLoading()
    }).then(async (result) => {
      if (result.isConfirmed) {
        fnGetData(bodyFilter)
      }
    })
  }

  return (
    <div>
      <NavTitle>
        <TextNavTitle>เบี้ยขยัน</TextNavTitle>
      </NavTitle>
      <NavRoleOrg />
      <CardCustom className="d-flex justify-content-between">
        <div>
          <div className="p-3">
            <Row>
              <Col md={4} className="my-auto small">
                <label>Total: {totalRows.toLocaleString()} </label>
              </Col>

              <Col md={8} className="gap-3 d-flex justify-content-end">
                <div style={{ width: 200 }}>
                  <CustomDatePicker
                    value={selectMonth}
                    showYearDropdown
                    isClearable={true}
                    placeholderText="Periods"
                    // renderMonthContent={renderMonthContent}
                    showMonthYearPicker
                    dateFormat="MM/yyyy"
                    onChange={(d) => {
                      if (d) {
                        const body = {
                          ...bodyFilter,
                          page: 1,

                          periodStartDate: fnDateEn(d).format('YYYY-MM-DD'),
                          periodEndDate: fnDateEn(d).format('YYYY-MM-DD')
                        }
                        fnGetData(body)
                      } else {
                        const body = {
                          ...bodyFilter,
                          page: 1,
                          periodStartDate: '',
                          periodEndDate: ''
                        }
                        fnGetData(body)
                      }
                      setSelectMonth(d)
                    }}
                  />
                </div>
                <Button
                  className="px-4 text-primary"
                  variant="light"
                  onClick={() => {
                    setShowFilter({ isShow: true, data: null })
                  }}
                >
                  <BsSliders2Vertical className="me-2" />
                  More Filter
                </Button>
                <Button
                  className=""
                  variant="light"
                  onClick={() => {
                    const body = {
                      page: 1,
                      periodStartDate: '',
                      periodEndDate: '',
                      orgId
                    }
                    fnGetData(body)
                  }}
                >
                  <BsArrowClockwise />
                </Button>
                <Button
                  className="px-4"
                  onClick={() => {
                    setShowImport({ isShow: true, data: null })
                  }}
                >
                  <FaPlus className="me-2" />
                  New Import
                </Button>
              </Col>
            </Row>
          </div>
          <Table hover>
            <thead
              className="bg-hrms text-white "
              style={{ position: 'sticky', top: '0px' }}
            >
              <tr className=" font-title-table">
                <th className="fw-normal">#</th>
                <th className="fw-normal">Periods</th>
                <th className="fw-normal">Count</th>
                <th className="text-end fw-normal">Total</th>
                <th className="fw-normal">Insert By</th>

                <th className="fw-normal">Insert Date</th>
                <th className="text-center fw-normal">Action</th>
              </tr>
            </thead>
            <tbody className="text-break fw-light">
              {isLoading ? (
                <TableSkeletonBody colSpan={7} rowSpan={7} />
              ) : dataTable.length > 0 ? (
                dataTable.map((d, i) => (
                  <tr className="font-small-2 align-middle" key={i}>
                    <td> {page * totalLimits - totalLimits + i + 1}</td>

                    <td className="">
                      {fnDateEn(d.periodDate).format('MM/YYYY')}
                    </td>
                    <td className="">{d.counts}</td>
                    <td className="text-end">
                      {d.diligenceAmounts?.toLocaleString()}
                    </td>
                    <td className="">{d.insertBy}</td>

                    <td className="">
                      {fnDateEn(d.insertDate).format('DD/MM/YYYY HH:mm')}
                    </td>

                    <td className="text-center">
                      <Link
                        className="btn btn-primary btn-sm me-2"
                        to={`${PAGE_INCOME_DILIG_DETAIL}?id=${d.periodDate}&orgId=${orgId}`}
                      >
                        <BsSearch />
                      </Link>
                      <Button
                        size="sm"
                        variant="light"
                        className="text-danger"
                        onClick={() => fnDeleteData(d.periodDate)}
                      >
                        <FaRegTrashCan />
                      </Button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr className="table-body">
                  <td colSpan={7} className="text-center">
                    -No Data-
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
        <div className="p-3">
          <PaginationControl
            page={page}
            total={totalRows}
            limit={totalLimits}
            changePage={(p) => {
              const body = {
                ...bodyFilter,
                page: p
              }
              fnGetData(body)
              setPage(p)
            }}
            ellipsis={1}
          />
        </div>
      </CardCustom>
      {showImport.isShow && (
        <ModalImportFile
          orgId={orgId}
          data={showImport.data}
          fnGetData={() => fnGetData(bodyFilter)}
          onCancel={() => setShowImport({ isShow: false, data: null })}
          open={showImport.isShow}
        />
      )}
      {showFilter.isShow && (
        <ModalMoreFilter
          bodyFilter={bodyFilter}
          fnGetData={(body) => fnGetData({ ...bodyFilter, ...body })}
          onCancel={() => setShowFilter({ isShow: false, data: null })}
          open={showFilter.isShow}
        />
      )}
    </div>
  )
}
